angular.module('wbDashboard').controller('PlansDetailControllerAurea', ['$scope', '$q', '$timeout', 'Track', 'PlanService', 'Message', function ($scope, $q, $timeout, Track, PlanService, Message) {

    $scope.featureInit = {};
    $scope.planFeatures = {};
    $scope.initPages = false;
    $scope.initPlan = false;
    $scope.disablingPlan = false;

    if ($scope.$stateParams.init) {
        //if first time after confirm on
    }

    $scope.$watch(function() { return $scope.PS.getPlan($scope.$stateParams.pslug); }, function(plan) {
        if (plan) {
            $scope.plan = plan;
            if (!plan.enabled) {
                $scope.$state.go('base.plans.info', {pslug: $scope.$stateParams.pslug}, {location: 'replace'});
                return;
            }

            $scope.featureInit = {};
            $scope.planFeatures = {};
            angular.forEach(plan.features, function(feature) {
                $scope.planFeatures[feature.slug] = feature;
                $scope.featureInit[feature.slug] = feature.enabled;
            });
        }
    });

    $scope.planDisableable = function() {
        var anyEnabled = false;
        if ($scope.featureInit) {
            angular.forEach($scope.featureInit, function (enabled, feature) {
                if (enabled) {
                    anyEnabled = true;
                }
            });
        }
        return !anyEnabled;
    };

    $scope.disablePlan = function(plan) {
        $scope.pageData.sending = true;

        /** @type {Promise[]} stores promises for each toggle call */
        var toggles = [];

        angular.forEach($scope.featureInit, function(enabled, featureSlug) {
            //should all be disabled at this point
            if ($scope.planFeatures[featureSlug].enabled) {
                var t = PlanService.user.toggleFeature(featureSlug, false);
                toggles.push(t);
            }
        });

        return $q.all(toggles).then(function(result) {
            return PlanService.user.removePlan(plan.slug);
        }).catch(function(response) {
            Message.set({
                text: "There was a problem disabling " + plan.display_name,
                type: "warning"
            });

            throw response;
        }).then(function() {
            var msg;
            switch (plan.slug) {
                case 'taxplan':
                    msg = plan.display_name + " Deactivated: The tax man thanks you...";
                    break;
                case 'fastmoney':
                    msg = plan.display_name + " Deactivated: Slowing it down.";
                    break;
                case 'portfolioplus':
                    msg = plan.display_name + " Deactivated.";
                    break;
            }
            Message.set({
                text: msg,
                type: "warning"
            });
            Track.send("Package Deactivated", "Services", {plan: plan.name});
            return PlanService.retrievePlans(true);
        }).finally(function() {
            //will be redirected by userPlan watcher
            $scope.pageData.sending = false;
        });
    };

    /**
     * Toggles plan features on or off
     * @param userFeature
     */
    $scope.toggleFeature = function(userFeature) {
        $scope.pageData.sending = true;
        var newStatus = !userFeature.enabled;
        return PlanService.user.toggleFeature(userFeature.slug, newStatus).catch(function(response) {
            Message.set({
                text: "Error updating feature",
                type: "warning"
            });

            throw response;
        }).then(function() {
            var message = false;
            if (newStatus) {
                message = $scope.toggleFeature.onMessage;
            } else {
                message = $scope.toggleFeature.offMessage;
            }
            if (message) {
                Message.set({
                    text: message,
                    type: "success",
                    key: "featuretoggle"
                });
            }
            Track.send("Feature Change", "Services", {name: userFeature.slug, feature: newStatus?"On":"Off"});

            return PlanService.retrievePlans(true);
        }).then(function() {
            if (typeof $scope.toggleFeature.complete == "function") {
                return $scope.toggleFeature.complete(userFeature, newStatus);
            }
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    /**
     * Will submit all the configured features from the init page
     */
    $scope.confirmFeatures = function() {
        $scope.pageData.sending = true;

        /** @type {Promise[]} stores promises for each toggle call */
        var toggles = [];
        angular.forEach($scope.featureInit, function(enabled, featureSlug) {
            if (enabled) {
                var t = PlanService.user.toggleFeature(featureSlug, enabled);
                toggles.push(t);
            }
        });

        return $q.all(toggles).then(function(result) {
            var trackData = {
                plan: $scope.plan.name
            };
            angular.forEach($scope.featureInit, function(value, index) {
                trackData[index] = value?"On":"Off";
            });
            Track.send("Package Activated", "Services", trackData);

            return PlanService.retrievePlans(true);
        }).then(function(result) {
            if ($scope.confirmFeatures.complete) {
                $scope.confirmFeatures.complete(result);
            } else {
                if ($scope.$state.includes('**.init')) {
                    $scope.$state.go('^', {}, {location: 'replace'});
                }
            }
        }).catch(function() {

        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    var transitionDeregisterHook = {};
    transitionDeregisterHook[0] = $scope.$transitions.onStart({ to: "base.plans.detail.plan.init" }, function(trans) {
        planInit();
    });
    transitionDeregisterHook[1] = $scope.$transitions.onStart({ to: "base.plans.detail.plan.disable" }, function(trans) {
        return planDeInit();
    });
    $scope.$on('$destroy', function() {
        angular.forEach(transitionDeregisterHook, function(hook) {
            if (typeof hook === "function") {
                hook();
            }
        });
    });
    if ($scope.$state.includes('**.init')) { planInit(); }
    if ($scope.$state.includes('**.disable')) {
        if (!$scope.$state.includes('**.plans.custom.**')) {
            //can't go directly here since autos need to load first
            $scope.$state.go("^", {}, {location: "replace"});
        }
    }

    function planInit() {
        //needs time for controller to load sub-controller with "initial" method
        //TODO: maybe use initPlan to trigger initial from detail controller...
        $scope.initPlan = true;
        $timeout(function() {
            if ($scope.confirmFeatures.initial) {
                $scope.confirmFeatures.initial();
            }
            $scope.initPlan = false;
        });
    }
    function planDeInit() {
        if ($scope.disablePlan.initial) {
            return $scope.disablePlan.initial();
        }
    }


}]);
